import {currency} from '../../../util';

export const UPLOAD_PRINT_LABEL = 'Upload & Print';

export interface UploadFeeLine {
    label: string;
    amount: string;
    applied: boolean;
    note: string;
}

/**
 * The Upload & Print line under the upload box (FS 10214). fee / applied are the last /api/pricing response's
 * upload_fee / upload_fee_applied (the server rule, view.product.UploadFee); null while the store charges nothing.
 */
export const uploadFeeLine = (fee: number, applied: boolean, docType: string): UploadFeeLine | null => {
    if (typeof fee !== 'number' || !Number.isFinite(fee) || fee <= 0) {
        return null;
    }
    const what = (docType || 'image').trim().toLowerCase() || 'image';
    return {label: UPLOAD_PRINT_LABEL, amount: currency(fee), applied, note: applied ? 'included in the price' : `added when you upload your ${what}`};
};
